
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch } from "react-redux";
import { Dialog } from "@progress/kendo-react-dialogs";

import ErrorHelper from "../../helper/error-helper";
import { NotificationManager } from "src/util/notify";
import InputKendoRct from "../../control-components/input/input";
import Loader from "../../control-components/loader/loader";
import { useSelector } from "react-redux";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import Utils from "../../helper/utils"
import { Error } from '@progress/kendo-react-labels';
import { RegionsService } from "../../services/regionsService";

function AddRegions({ onClose }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState("");
    const [settingError, setSettingError] = useState(false);

    let [fields, setFields] = useState({
        regionName: "",

    });


    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;
        if (!fields.regionName || fields.regionName.trim().length === 0) {
            formIsValid = false;
            errors["regionName"] = ErrorHelper.REGION;
        }

        setErrors(errors);
        return formIsValid;
    };

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFields({
            ...fields,
            [name]: value,
        });
    };


    const handleSubmit = (event) => {
        setSettingError(true);
        if (handleValidation()) {
            addRegions();
        }
    };


    const addRegions = async () => {
        setLoading(true)
        await RegionsService.insertRegions(fields)
            .then(result => {
                setLoading(false)
                NotificationManager.success(NOTIFICATION_MESSAGE.REGIONS_ADDED);
                onClose({ "updated": true });
            }).catch(error => {
                setLoading(false)
                NotificationManager.error(error);
            });
    }

    return (
        <Dialog
            onClose={onClose}
            title={"Add Region"}
            className="small-dailog"
        >
            <div className="edit-Service-popup dialog-edit py-3">
                <div className="mx-3">
                    <div className="row align-items-center">
                        <div className="col-12 mb-1">
                            <InputKendoRct
                                value={fields.regionName}
                                onChange={handleChange}
                                name="regionName"
                                label="Region Name"
                                error={fields.regionName == "" && errors.regionName}
                                validityStyles={settingError}
                                required={true}
                                className="form-control"
                                placeholder={"Region Name"}
                            />
                        </div>
                    </div>
                </div>
                {loading == true && <Loader />}
            </div>


            <div className="border-bottom-line"></div>
            <div className="d-flex my-4">
                    <button
                        className="btn green-btn  btn-primary btn-space text-white border-0 mx-3"
                        onClick={handleSubmit}
                    >
                        Add
                    </button>
                    <button
                        className="btn grey-secondary btn-space "
                        onClick={onClose}
                    >
                        Cancel
                    </button>
            </div>
        </Dialog>
    );
}
export default AddRegions;



